import React, {
  Fragment,
  useEffect,
  useState,
  useRef,
  useCallback,
} from 'react';
import { useSelector, useDispatch } from 'react-redux';
//import GoogleMapReact from 'google-map-react';

//import PlacesAutocomplete from './PlacesAutocomplete';
import { query, changeMode } from '../../Actions/SaddleTestingLocations.action';
import { translate } from '../../Services/translation';
import constants, { ViewMode, gmId } from '../../constants';
import { calcDistance, sortDistances } from './mapFunctions';

const SaddleTestingLocationsContainer = () => {
  const showAllConstant = 'all';

  const mapRef = useRef();
  const list = useSelector((state) => state.dealerInfo.list);
  const dispatch = useDispatch();
  const [mapApi, setMapApi] = useState();
  const [placesService, setPlacesService] = useState();
  const [mapInstance, setMapInstance] = useState();
  const [mapApiLoaded, setMapApiLoaded] = useState(false);
  const [selectedDealer, setSelectedDealer] = useState('');
  const [googleMapsKey, setGoogleMapsKey] = useState(constants.gmId);
  const [zoom, setZoom] = React.useState(7);
  const [dealers, setDealers] = useState([]);
  const [regions, setRegions] = React.useState([]);
  const [activeRegion, setActiveRegion] = useState(showAllConstant);
  const [countries, setCountries] = React.useState([]);
  const [activeCountry, setActiveCountry] = useState(showAllConstant);
  const [disableFilter, setDisableFilter] = useState(false);
  const [dealerTypes, setDealerTypes] = React.useState([]);
  const [activeDealerType, setActiveDealerType] = useState(showAllConstant);
  const [filterRegions, setFilterRegions] = React.useState([]);
  const [mounted, setMounted] = useState(false);
  const [positioningEnabled, setPositioningEnabled] = useState(true);
  //const [showMoreIndexes, setShowMoreIndexes] = useState([]);

  const [position, setPosition] = useState({
    lat: 0,
    lng: 0,
  });

  const [positionLocal, setPositionLocal] = useState({
    lat: 0,
    lng: 0,
  });

  useEffect(() => {
    dispatch(query());
  }, [dispatch]);

  const fixCountryName = (dealer) => {
    let name = dealer.dealerAddressData?.country || '';
    if (name.toLowerCase() === 'noreg') {
      name = 'Norge';
    }
    return name;
  };

  const setFilters = (newFilterList = null, filterDealerType = null) => {
    if (list && list.length > 0) {
      let currentRegions = [...regions];
      let currentRegionsDealerData = [];
      let currentCountries = [...countries];
      let currentCountriesDealerData = [];
      const _showMoreIndxes = [];
      list.map((dealer) => {
        const dealerRegion = dealer.region;
        const dealerCountry = fixCountryName(dealer);
        _showMoreIndxes.push(false);

        if (dealerRegion && !currentRegions.includes(dealerRegion)) {
          currentRegions = [...currentRegions, dealerRegion];
        }

        if (dealerCountry && !currentCountries.includes(dealerCountry)) {
          currentCountries = [...currentCountries, dealerCountry];
        }
      });
      setRegions([...currentRegions]);
      setCountries([...currentCountries]);
      /*setShowMoreIndexes(_showMoreIndxes);*/
      filterList();
    }
  };
  const filterList = () => {
    if (!list) {
      return;
    }

    let newDealers = [...list];

    // Region
    newDealers = newDealers?.filter(
      (x) => x.region === activeRegion || activeRegion === showAllConstant
    );

    // Region
    newDealers = newDealers?.filter(
      (x) =>
        fixCountryName(x) === activeCountry || activeCountry === showAllConstant
    );
    setDealers(newDealers);
  };

  const getDealerAddress = (dealer) => {
    let dealerAddr = dealer?.dealerAddressData?.city || '';
    if (dealer?.dealerAddressData?.address) {
      if (dealerAddr.length > 2) {
        dealerAddr += ', ';
        dealerAddr += dealer.dealerAddressData.address;
      }
    }
    return dealerAddr;
  };

  const toggleRegion = (e) => {
    const region = e.target.value;
    setActiveRegion(region);
  };

  //const toggleShowMore = (index) => {
  //  const _showMoreIndxes = [...showMoreIndexes];
  //  _showMoreIndxes[index] = !_showMoreIndxes[index];
  //  setShowMoreIndexes(_showMoreIndxes);
  //};

  const toggleCountry = (e) => {
    const country = e.target.value;
    setActiveCountry(country);
  };

  const isSweden = (country) => {
    return (
      country.toLowerCase() === 'sverige' || country.toLowerCase() === 'sweden'
    );
  };
  const isWithFilter = (country) => {
    return isSweden(country) || country === showAllConstant;
  };

  useEffect(() => {
    if (mounted) {
      filterList();
    }
  }, [activeRegion, activeCountry]);

  useEffect(() => {
    if (mounted && activeCountry) {
      const isFilterDisabled = !isWithFilter(activeCountry);
      setDisableFilter(isFilterDisabled);
      if (isFilterDisabled) {
        setActiveRegion(showAllConstant);
      }
    }
  }, [activeCountry]);

  useEffect(() => {
    async function setup() {
      if (!mounted) {
        setFilters();
        setMounted(true);
      }
    }
    setup();
  }, []);

  useEffect(() => {
    if (mounted) {
      setFilters();
    }
  }, [list, position]);

  return (
    <div className=" saddle-testing-location-page__form-wrapper">
      <div className="row align-center saddle-testing-location-page__form-filter">
        <div className="small-12 large-3 columns">
          <label htmlFor="dpCountries">{translate('dealer.countries')}</label>
          <div className="saddle-testing-location-page__region-select-wrapper">
            <select
              className=""
              type="text"
              id="dpCountries"
              name="dpCountries"
              onChange={(e) => toggleCountry(e)}
            >
              <option value="all"> - </option>
              {countries &&
                countries.map((country, countryIndex) => (
                  <option
                    key={`dealerCountryList${countryIndex}`}
                    value={country}
                    selected={isSweden(country)}
                  >
                    {country}
                  </option>
                ))}
            </select>
            <i></i>
          </div>
        </div>
        <div className=" small-12 large-3 columns">
          <label htmlFor="deRegion">{translate('dealer.region')}</label>
          <div className="saddle-testing-location-page__region-select-wrapper">
            <select
              className=""
              type="text"
              id="deRegion"
              name="deRegion"
              onChange={(e) => toggleRegion(e)}
              disabled={disableFilter}
            >
              <option value="all" selected={disableFilter}>
                {' '}
                -{' '}
              </option>
              {regions &&
                regions.map((region, regionIndex) => (
                  <option key={`dealerRegionList${regionIndex}`} value={region}>
                    {region}
                  </option>
                ))}
            </select>
            <i></i>
          </div>
        </div>
      </div>
      <div className="row align-center">
        {dealers && dealers.length > 0 && (
          <ul className="row small-up-1 medium-up-2 large-up-4 saddle-testing-location-page__dealer-list">
            {dealers.map((dealer, index) => (
              <li
                id={`saddleTestingLocationsPageListItem_${index}`}
                className={`column saddle-testing-location-page__dealer-list-item${
                  selectedDealer === dealer.name ? '--active' : ''
                }`}
                key={`dalerList${index}`}
              >
                <address>
                  <h3>{dealer.name}</h3>

                  {(dealer.dealerAddressData.city ||
                    dealer.dealerAddressData.address) && (
                    <div className="saddle-testing-location-page__dealer-list-item-address">
                      {getDealerAddress(dealer)}
                    </div>
                  )}
                  {dealer.website && dealer.website.length > 1 && (
                    <div className="saddle-testing-location-page__dealer-list-item-website">
                      <a
                        target="_blank"
                        href={
                          dealer.website.toLowerCase().indexOf('//') !== -1
                            ? dealer.website
                            : '//' + dealer.website
                        }
                      >
                        {dealer.website}
                      </a>
                    </div>
                  )}
                  
                  {dealer.contactName && (
                    <div className="saddle-testing-location-page__dealer-list-item-phone">
                      {dealer.contactName}
                    </div>
                  )}

                  {dealer.dealerAddressData.phoneNumber && (
                      <div className="saddle-testing-location-page__dealer-list-item-phone">
                        <a href={`tel:${dealer.dealerAddressData.phoneNumber}`}>
                          {dealer.dealerAddressData.phoneNumber}
                        </a>
                      </div>
                    )}
                  {dealer.dealerAddressData.email && (
                    <div className="saddle-testing-location-page__dealer-list-item-email">
                      <a
                        href={`mailto:${dealer.dealerAddressData.email.toLowerCase()}`}
                      >
                         {dealer.dealerAddressData.email.toLowerCase()}
                      </a>
                    </div>
                  )}
                </address>

                {/*<h5>{dealer.distance}</h5>*/}
                {false && dealer.regions && (
                  <ul>
                    {dealer.regions.map((region, regionIndex) => (
                      <li key={`regionList${regionIndex}`}>
                        <a href={region.url}>
                          {' '}
                          {region.name}
                          <br />
                        </a>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};
export default React.memo(SaddleTestingLocationsContainer);
